import type React from 'react';

import {useInteractAnywhere} from '../hooks/useInteractAnywhere';

import {type PopoverProps} from '../components/popover';
import {useUiConfig} from '../providers/UiConfigProvider';
import {usePartialIframe} from './OverlayOverrides';

export const usePopoverIframe = (props: PopoverProps) => {
  const uiConfig = useUiConfig();
  const getUILayers = uiConfig?._unstable_getUILayers;

  const handleClose = (event: React.SyntheticEvent) => {
    if (
      props.onClose &&
      event.target !== props.targetRef.current &&
      !props.targetRef.current?.contains(event.target as Node)
    ) {
      props.onClose();
    }
  };
  useInteractAnywhere(handleClose, props.targetRef.current?.ownerDocument);

  return usePartialIframe({
    ...props,
    uiLayers: getUILayers ? getUILayers() : [],
  });
};
